import { httpGet } from "../../../../../common/network/fetch";
import { GetActiveReturnRequestQuery } from "./get-active-return-request-query";
import { IBtmReturnRequestListDto } from "../../model/btm-return-request-list";
import { BtmReturnRequestListItem } from "../../model/btm-return-request-list-item";

export const GetActiveReturnRequestHandler = async (query: GetActiveReturnRequestQuery) => {
    return (await httpGet<IBtmReturnRequestListDto>({ url: `/return-request/list/warehouse/${query.warehouseCode}` }, false))
        .returnRequestListItems
        .filter(Boolean)
        .filter(dto => dto.status === "New"
            || dto.status === "Pending"
            || dto.status === "Processed")
        .map(dto => new BtmReturnRequestListItem(dto));
};
